<template>
    <button class="button button--primary button--compact" @click="logout">
        Log Out
    </button>
</template>

<script setup lang="ts">
    import { useAuth0 } from "@/Services/Auth0/auth0-plugin";
    import { Auth0 } from '@/Services/Auth0/auth0-interface'
    
    const auth0: Auth0 | null = useAuth0();

    const logout = () => {
        if (!auth0) {
            return;
        }

        auth0.logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    };

            
</script>
